import '../../Styles/Tabs/tabs.scss';

window.am = window.am || {};

window.am.tabs = new function () {
    var that = this;

    var keys = {
        end: 35,
        home: 36,
        left: 37,
        up: 38,
        right: 39,
        down: 40,
        delete: 46,
        enter: 13,
        space: 32
    };

    var direction = {
        37: -1,
        38: -1,
        39: 1,
        40: 1
    };
    
    that.init = function () {
        var tabsRenderings = document.querySelectorAll('.tabs');
        tabsRenderings.forEach(function (tabsRendering) {
            var tabs = tabsRendering.querySelectorAll('.tabs__tab');
            if (tabs.length == 0) {
                return;
            }

            var firstTab = tabs[0];
            that.activateTab(firstTab);

            tabs.forEach(function(tab) {
                tab.addEventListener('click', that.onTabClick);
                tab.addEventListener('mouseenter', that.onTabHover);
                tab.addEventListener('mouseleave', that.onTabBlur);
                tab.addEventListener('focus', that.onTabHover);
                tab.addEventListener('blur', that.onTabBlur);
                tab.addEventListener('keydown', that.onKeyDown);
                tab.addEventListener('keyup', that.onKeyUp);
            });

            that.getIndicator(firstTab).style.width = 'calc(100% / ' + tabs.length + ')';
            that.getPreIndicator(firstTab).style.width = 'calc(100% / ' + tabs.length + ')';
        });
    };

    that.onTabClick = function() {
        that.activateTab(this);
    };

    that.onTabHover = function () {
        that.setPreIndicator(this);
    };

    that.onTabBlur = function () {
        var activeTab = that.getActiveTab(this);
        that.setPreIndicator(activeTab);
    };

    that.onKeyDown = function (event) {
        var tabs = that.getAllTabs(this);

        switch (event.keyCode) {
        case keys.end:
            event.preventDefault();
            // Activate last tab
            that.focusTab(tabs[tabs.length - 1]);
            break;
        case keys.home:
            event.preventDefault();
            // Activate first tab
            that.focusTab(tabs[0]);
            break;
        case keys.up:
        case keys.down:
            that.switchTabOnArrowPress(this, event);
            break;
        };
    };

    // Handle keyup on tabs
    that.onKeyUp = function (event) {
        switch (event.keyCode) {
        case keys.left:
        case keys.right:
            that.switchTabOnArrowPress(this, event);
            break;
        };
    };

    that.switchTabOnArrowPress = function (tab, event) {
        var pressed = event.keyCode;
        var tabs = that.getAllTabs(tab);

        if (direction[pressed]) {
            var tabIndex = that.getTabIndex(tab);
            if (tabIndex !== undefined) {
                if (tabs[tabIndex + direction[pressed]]) {
                    that.focusTab(tabs[tabIndex + direction[pressed]]);
                }
                else if (pressed === keys.left || pressed === keys.up) {
                    that.focusTab(tabs[tabs.length - 1]);
                }
                else if (pressed === keys.right || pressed == keys.down) {
                    that.focusTab(tabs[0]);
                };
            };
        };
    };

    that.activateTab = function(tab) {
        if (typeof tab == "undefined" || tab == null) {
            return;
        }

        that.getAllTabs(tab).forEach(function (currentTab) {
            var currentTabElement = that.getTabElement(currentTab);
            currentTabElement.setAttribute('hidden', '');
            currentTab.setAttribute('aria-selected', false);
            currentTab.setAttribute('tabIndex', '-1');
        });

        var tabElement = that.getTabElement(tab);
        tab.setAttribute('aria-selected', true);
        tab.setAttribute('tabIndex', '0');
        tabElement.removeAttribute('hidden');

        that.setIndicator(tab);
        that.setPreIndicator(tab);
    };

    that.focusTab = function (tab) {
        if (typeof tab == "undefined" || tab == null) {
            return;
        }
        
        var activeTab = that.getActiveTab(tab);
        that.getAllTabs(tab).forEach(function (currentTab) {
            if (currentTab !== tab && currentTab !== activeTab) {
                currentTab.setAttribute('tabIndex', '-1');
            }
        });

        tab.setAttribute('tabIndex', '0');
        tab.focus();
    };

    that.getTabElement = function(tab) {
        if (typeof tab == "undefined" || tab == null) {
            return;
        }

        var tabElementSelectors = '#' + tab.getAttribute('aria-controls');
        var tabRendering = that.getTabRendering(tab);

        return tabRendering.querySelector(tabElementSelectors);
    };

    that.getTabRendering = function(tab) {
        if (typeof tab == "undefined" || tab == null) {
            return;
        }

        return tab.closest('.tabs');
    };

    that.getAllTabs = function(tab) {
        if (typeof tab == "undefined" || tab == null) {
            return;
        }

        var tabRendering = that.getTabRendering(tab);
        return tabRendering.querySelectorAll('.tabs__tab');
    };

    that.getTabIndex = function (tab) {
        var indexFound;

        that.getAllTabs(tab).forEach(function(currentTab, index) {
            if (tab === currentTab) {
                indexFound = index;
            }
        });

        return indexFound;
    };

    that.getActiveTab = function(tab) {
        var tabFound;

        that.getAllTabs(tab).forEach(function (currentTab) {
            if (currentTab.getAttribute('aria-selected') === 'true') {
                tabFound = currentTab;
            }
        });

        return tabFound;
    };

    that.getIndicator = function(tab) {
        if (typeof tab == "undefined" || tab == null) {
            return;
        }

        return that.getTabRendering(tab)
            .querySelector('.tabs__indicator');
    };

    that.getPreIndicator = function (tab) {
        if (typeof tab == "undefined" || tab == null) {
            return;
        }

        return that.getTabRendering(tab)
            .querySelector('.tabs__pre-indicator');
    };

    that.setIndicator = function (tab) {
        if (typeof tab == "undefined" || tab == null) {
            return;
        }

        var indicator = that.getIndicator(tab);
        var tabIndex = that.getTabIndex(tab);
        indicator.style.transform = 'translatex(' + (100 * tabIndex) + '%)';
    };

    that.setPreIndicator = function (tab) {
        if (typeof tab == "undefined" || tab == null) {
            return;
        }

        var preIndicator = that.getPreIndicator(tab);
        var tabIndex = that.getTabIndex(tab);
        preIndicator.style.transform = 'translatex(' + (100 * tabIndex) + '%)';

        if (that.getActiveTab(tab) === tab) {
            preIndicator.style.opacity = 0;
        } else {
            preIndicator.style.opacity = 1;
        }
    };
};

window.am.tabs.init();